import { getEnvironment } from '../../api/api'

const KR_ENVIRONMENT = 'production'

export const isKrEnvironment = (): boolean => getEnvironment() === KR_ENVIRONMENT
